/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs */

const en__field__enum_primarystudyinterest_study_protestant_theology25 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protestant Theology`)
};

const de__field__enum_primarystudyinterest_study_protestant_theology25 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evangelische Theologie`)
};

/**
* | output |
* | --- |
* | "Protestant Theology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_protestant_theology25 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Protestant_Theology25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_protestant_theology25(inputs)
	return de__field__enum_primarystudyinterest_study_protestant_theology25(inputs)
});
export { _field__enum_primarystudyinterest_study_protestant_theology25 as "_field__enum_primaryStudyInterest_STUDY_PROTESTANT_THEOLOGY" }